import { render } from "./HomeTilesMenu.vue?vue&type=template&id=6b68afc3&scoped=true"
import script from "./HomeTilesMenu.vue?vue&type=script&lang=js"
export * from "./HomeTilesMenu.vue?vue&type=script&lang=js"

import "./HomeTilesMenu.vue?vue&type=style&index=0&id=6b68afc3&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b68afc3"]])

export default __exports__